import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (role && user.role !== role) {
    const redirect = user.role === 'OWNER' ? '/dashboard' : '/report';
    return <Navigate to={redirect} replace />;
  }

  return children;
}

export default ProtectedRoute;
